"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toast = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var timer;
var Toast = /** @class */function (_super) {
  __extends(Toast, _super);
  function Toast() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      showNotification: false
    };
    _this.getIconClass = function () {
      switch (_this.props.type) {
        case 'info':
          return 'fa fa-info-circle vdl-toast-info';
        case 'success':
          return 'fa fa-check-circle vdl-toast-success';
        case 'warning':
          return 'fa fa-exclamation-triangle vdl-toast-warning';
        case 'error':
          return 'fa fa-exclamation-circle vdl-toast-error';
        default:
          return 'fa fa-info-circle vdl-toast-info';
      }
    };
    _this.showToast = function () {
      _this.setState({
        showNotification: true
      });
      _this.props.onOpen && _this.props.onOpen();
    };
    _this.hideToast = function () {
      _this.setState({
        showNotification: false
      });
      _this.props.onClose && _this.props.onClose();
    };
    return _this;
  }
  Toast.prototype.componentDidMount = function () {
    var _this = this;
    timer = setTimeout(function () {
      _this.showToast();
    }, 200);
    timer = setTimeout(function () {
      _this.hideToast();
    }, this.props.timeout + 200);
  };
  Toast.prototype.componentWillUnmount = function () {
    clearTimeout(timer);
  };
  Toast.prototype.render = function () {
    var _a;
    var _b = this.props,
      className = _b.className,
      icon = _b.icon,
      message = _b.message,
      type = _b.type;
    var toastClasses = (_a = {}, _a[vdl_prefix_1.vdlPrefix('toast')] = true, _a[vdl_prefix_1.vdlPrefix("toast--" + type)] = true, _a);
    return react_1.default.createElement("div", {
      className: classnames_1.classNames(className, toastClasses),
      style: {
        marginTop: this.state.showNotification ? '0' : '-100%'
      }
    }, icon ? icon : react_1.default.createElement("div", {
      className: this.getIconClass()
    }), react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('toast-message')
    }, message));
  };
  Toast.propTypes = {
    className: prop_types_1.default.string,
    type: prop_types_1.default.oneOf(['info', 'success', 'warning', 'error']),
    children: prop_types_1.default.node
  };
  Toast.defaultProps = {
    type: 'info',
    message: 'notification message missing...',
    timeout: 10000
  };
  return Toast;
}(react_1.default.Component);
exports.Toast = Toast;